// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"aad69756","608":"9cb043f3"}[chunkId] + ".chunk.js";
};